var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon8({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 107,
    viewBox: "0 0 106 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.2104 67.0625V68.0625H44.2104H61.7886H62.7886V67.0625V65.1477C62.7886 63.0665 61.097 61.375 59.0159 61.375H46.9831C44.9023 61.375 43.2104 63.0665 43.2104 65.1477V67.0625ZM62.9604 68.4062H43.0386C42.9436 68.4062 42.8667 68.3293 42.8667 68.2344V65.1477C42.8667 62.8788 44.7142 61.0312 46.9831 61.0312H59.0159C61.2848 61.0312 63.1323 62.8788 63.1323 65.1477V68.2344C63.1323 68.3293 63.0554 68.4062 62.9604 68.4062Z",
    fill: "#BA83B8",
    stroke: "#4D2481",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9995 50.8281C52.9047 50.8281 52.8276 50.7511 52.8276 50.6562V1.4375C52.8276 1.34268 52.9047 1.26562 52.9995 1.26562C53.0944 1.26562 53.1714 1.34255 53.1714 1.4375V50.6562C53.1714 50.7511 53.0943 50.8281 52.9995 50.8281Z",
    fill: "#4D2481",
    stroke: "#4D2481",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M104.148 68.2344C104.148 70.9181 101.972 73.0938 99.2886 73.0938C96.6048 73.0938 94.4292 70.9181 94.4292 68.2344C94.4292 65.5506 96.6048 63.375 99.2886 63.375C101.972 63.375 104.148 65.5506 104.148 68.2344Z",
    fill: "#BA83B8",
    stroke: "#4D2481",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9136 88.1562C13.9136 90.84 11.738 93.0156 9.0542 93.0156C6.37044 93.0156 4.19482 90.84 4.19482 88.1562C4.19482 85.4725 6.37044 83.2969 9.0542 83.2969C11.738 83.2969 13.9136 85.4725 13.9136 88.1562Z",
    fill: "#BA83B8",
    stroke: "#4D2481",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2425 65.8906C66.0711 65.8906 35.6712 65.8906 29.7565 65.8906C26.0909 65.8906 23.1167 68.8648 23.1167 72.5305V99.0945C23.1167 102.76 26.0909 105.734 29.7565 105.734H76.2425C79.9081 105.734 82.8823 102.76 82.8823 99.0945C82.8823 94.3241 82.8823 75.6228 82.8823 72.5305C82.8826 68.8648 79.9081 65.8906 76.2425 65.8906Z",
    fill: "#BA83B8",
    stroke: "#4D2481",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1636 75.2656V105.734H62.9604V75.2656V65.8906H71.1636V75.2656Z",
    fill: "#BA83B8",
    stroke: "#4D2481",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0386 75.2656V105.734H34.8354V75.2656V65.8906H43.0386V75.2656Z",
    fill: "#BA83B8",
    stroke: "#4D2481",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8823 72.5305V75.2656H71.1636V65.8906H76.2425C79.9079 65.8906 82.8823 68.8648 82.8823 72.5305Z",
    fill: "#BA83B8",
    stroke: "#4D2481",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0386 65.8906H62.9604V75.2656H43.0386V65.8906Z",
    fill: "#BA83B8",
    stroke: "#4D2481",
    strokeWidth: 2
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8354 65.8906V75.2656H23.1167V72.5305C23.1167 68.8648 26.0909 65.8906 29.7565 65.8906H34.8354Z",
    fill: "#BA83B8",
    stroke: "#4D2481",
    strokeWidth: 2
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8354 75.2656V105.734H29.7565C26.0909 105.734 23.1167 102.76 23.1167 99.0945V75.2656H34.8354Z",
    fill: "#E7E0F0",
    stroke: "#4D2481",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8823 75.2656V99.0945C82.8823 102.76 79.9081 105.734 76.2425 105.734H71.1636V75.2656H82.8823Z",
    fill: "#E7E0F0",
    stroke: "#4D2481",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0386 75.2656H62.9604V105.734H43.0386V75.2656Z",
    fill: "#E7E0F0",
    stroke: "#4D2481",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5435 5.20391C78.556 5.50625 98.595 25.5242 98.3677 50.518C98.3677 44.3047 93.394 38.457 87.1763 38.382C80.9302 38.307 75.7997 43.2969 75.6966 49.5406H75.6895C75.6893 24.9992 65.8856 5.35156 53.5435 5.20391Z",
    fill: "#BA83B8",
    stroke: "#4D2481",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9994 5.21328V48.6688C52.7369 42.7039 47.8549 37.9086 41.8057 37.8336C35.8666 37.7633 30.9377 42.268 30.3799 48.0758C31.3197 24.5609 41.1445 5.63281 52.9994 5.21328Z",
    fill: "#BA83B8",
    stroke: "#4D2481",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9995 48.6688V5.21328C53.1354 5.20625 53.269 5.20391 53.405 5.20391H53.5433C65.8855 5.35156 75.6891 24.9992 75.6891 49.5406C75.6891 49.8664 75.6868 50.1922 75.6823 50.518C75.6823 44.3 70.7087 38.1828 64.4909 38.1078C58.2261 38.0328 53.0862 43.0484 53.0112 49.3133C53.0133 49.0977 53.011 48.882 52.9995 48.6688Z",
    fill: "#E7E0F0",
    stroke: "#4D2481",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M30.38 48.0758C30.3472 48.3922 30.3308 48.7156 30.3261 49.0414C30.4011 42.7766 25.3832 37.6367 19.1207 37.5617C12.9545 37.4867 7.85895 44.1781 7.63184 50.3633C8.08418 25.6203 28.2873 5.20156 52.9996 5.20156V5.21328C41.1446 5.63281 31.3199 24.5609 30.38 48.0758Z",
    fill: "#E7E0F0",
    stroke: "#4D2481",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M100.409 81.1757L100.41 81.176C100.706 81.4721 100.706 81.9497 100.41 82.2459L100.409 82.2461C100.113 82.5424 99.6358 82.5424 99.3396 82.2461L99.3394 82.2459C99.0431 81.9497 99.0431 81.4721 99.3394 81.176L99.3395 81.1759C99.6358 80.8796 100.113 80.8798 100.409 81.1757Z",
    fill: "#E7E0F0",
    stroke: "#4D2481",
    strokeWidth: 2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M95.9439 9.05469C95.9439 9.47257 95.6052 9.81133 95.1873 9.81133C94.7694 9.81133 94.4307 9.47257 94.4307 9.05469C94.4307 8.6368 94.7694 8.29805 95.1873 8.29805C95.6052 8.29805 95.9439 8.6368 95.9439 9.05469Z",
    fill: "#E7E0F0",
    stroke: "#4D2481",
    strokeWidth: 2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3471 54.2226L86.3473 54.2228C86.6436 54.519 86.6436 54.9966 86.3473 55.2928L86.3471 55.293C86.0509 55.5893 85.5733 55.5893 85.2771 55.293L85.2769 55.2928C84.9806 54.9966 84.9806 54.519 85.2769 54.2228L85.277 54.2227C85.5733 53.9265 86.0512 53.9266 86.3471 54.2226Z",
    fill: "#E7E0F0",
    stroke: "#4D2481",
    strokeWidth: 2
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3784 103.34L18.3781 103.34C18.082 103.636 17.6044 103.636 17.3082 103.34L17.3081 103.34C17.0119 103.044 17.0119 102.566 17.3081 102.27C17.6043 101.973 18.0823 101.974 18.3781 102.269L18.3784 102.27C18.6746 102.566 18.6746 103.043 18.3784 103.34Z",
    fill: "#E7E0F0",
    stroke: "#4D2481",
    strokeWidth: 2
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7223 5.51726L17.7224 5.51738C18.0187 5.81355 18.0187 6.29348 17.7224 6.58965L17.7223 6.58977C17.4261 6.88603 16.946 6.88586 16.6502 6.58989L16.6499 6.58965C16.3537 6.29348 16.3537 5.81355 16.6499 5.51738L16.6502 5.51714C16.946 5.22117 17.4261 5.221 17.7223 5.51726Z",
    fill: "#E7E0F0",
    stroke: "#4D2481",
    strokeWidth: 2
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6909 63.4959L13.6906 63.4961C13.3945 63.7924 12.9169 63.7924 12.6207 63.4961L12.6206 63.496C12.3244 63.1998 12.3244 62.722 12.6206 62.4259C12.9168 62.1296 13.3948 62.1298 13.6906 62.4257L13.6909 62.426C13.9871 62.7221 13.9871 63.1997 13.6909 63.4959Z",
    fill: "#E7E0F0",
    stroke: "#4D2481",
    strokeWidth: 2
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M3.14399 35.3709L3.14387 35.371C2.84768 35.6672 2.3699 35.6672 2.07371 35.371C1.77751 35.0748 1.77751 34.5971 2.07371 34.3009C2.36997 34.0046 2.84788 34.0048 3.14375 34.3007L3.14399 34.301C3.44026 34.5971 3.44026 35.0747 3.14399 35.3709Z",
    fill: "#E7E0F0",
    stroke: "#4D2481",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon8);
export default __webpack_public_path__ + "static/media/icon-8.6125c6e676e275d392c6901f7c9afdd7.svg";
export { ForwardRef as ReactComponent };